import React from 'react';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Alert from "@mui/material/Alert";
import {useCollection} from "react-firebase-hooks/firestore";
import {collection} from "firebase/firestore";

import {getFirebase} from "../../config/firebase.config";
import {StyledMenu} from "../common/StyledMenu";
import Loading from "../common/Loading";
import Title from "../common/Title";

const DashboardEvvList = () => {
    const {firestore} = getFirebase();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [value, loading, error] = useCollection(collection(firestore, 'evvPool'), {snapshotListenOptions: {includeMetadataChanges: true}});
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    if (loading) {
        return <Loading/>
    }
    return (
        <React.Fragment>
            <Title>Missed Evvs</Title>
            <TableContainer component={Paper} sx={{maxHeight: 650}}>
                {error && <Alert severity="error">{error.message}</Alert>}
                <Table stickyHeader size="medium">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{fontWeight: 'bold'}}>CreatedAt</TableCell>
                            <TableCell sx={{fontWeight: 'bold'}}>Employee Name</TableCell>
                            <TableCell sx={{fontWeight: 'bold'}}>Consumer Name</TableCell>
                            <TableCell sx={{fontWeight: 'bold'}}>Missed Date</TableCell>
                            <TableCell sx={{fontWeight: 'bold'}}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {value && value.docs.map((doc) => (
                            <TableRow key={doc.id}>
                                <TableCell>{doc.data().timestamp.toDate().toLocaleString()}</TableCell>
                                <TableCell>{doc.data().empName}</TableCell>
                                <TableCell>{doc.data().consumerName}</TableCell>
                                <TableCell>{doc.data().evvDate.toDate().toLocaleDateString()}</TableCell>
                                <TableCell>
                                    <Button
                                        id="demo-customized-button"
                                        aria-controls={open ? 'demo-customized-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        variant="contained"
                                        disableElevation
                                        onClick={handleClick}
                                        endIcon={<KeyboardArrowDownIcon/>}
                                    >
                                        Action
                                    </Button>
                                    <StyledMenu
                                        id="demo-customized-menu"
                                        MenuListProps={{
                                            'aria-labelledby': 'demo-customized-button',
                                        }}
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                    >
                                        <MenuItem onClick={handleClose} disableRipple>
                                            <CheckIcon/>
                                            Approve
                                        </MenuItem>
                                        <MenuItem onClick={handleClose} disableRipple>
                                            <CloseIcon/>
                                            Disapprove
                                        </MenuItem>
                                        <Divider sx={{my: 0.5}}/>
                                        <MenuItem onClick={handleClose} disableRipple>
                                            <ArchiveIcon/>
                                            Archive
                                        </MenuItem>
                                    </StyledMenu>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
};

export default DashboardEvvList;